"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M28.286 28a5.714 5.714 0 1 0 0-11.429 5.777 5.777 0 0 0-.645.037 7.239 7.239 0 1 0-14.153-2.876 6.1 6.1 0 0 0-7.473 7.461A3.429 3.429 0 1 0 5.43 28z" })
);

